/**
 * The one way to print a customer's (aleno restaurant group's) name.
 *
 * aleno names a customer without a real group "Default" (or leaves it
 * empty). That placeholder names nobody, so it never appears in a label:
 * this returns null and the caller falls back to neutral wording ("this
 * customer's venues", "All venues of the group"). The server applies the
 * same rule (`app/data/customer_name.py`); this guards older payloads.
 */
const PLACEHOLDERS = new Set(['default']);

export function customerLabel(name: string | null | undefined): string | null {
  const clean = (name || '').trim();
  return clean && !PLACEHOLDERS.has(clean.toLowerCase()) ? clean : null;
}
